import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr";
import "../date.js";
import { German as LocaleDE } from "flatpickr/dist/l10n/de.js"
import { French as LocaleFR } from "flatpickr/dist/l10n/fr.js"
import { Italian as LocaleIT } from "flatpickr/dist/l10n/it.js"
import { english as LocaleEN } from "flatpickr/dist/l10n/default.js"

// Connects to data-controller="login"
export default class extends Controller {
  static targets = ["form", "invoiceDate"]

  connect() {

    let localeToUse = LocaleEN;

    if (document.body.attributes["locale"].value == "de") {
      localeToUse = LocaleDE
    }
    else if (document.body.attributes["locale"].value == "fr") {
      localeToUse = LocaleFR
    }
    else if (document.body.attributes["locale"].value == "it") {
      localeToUse = LocaleIT
    }

    this.fpStartDate = flatpickr("#startDateWrapper", {
      dateFormat: "d.m.Y",
      weekNumbers: "true",
      wrap: true,
      locale: localeToUse,
      altInput: true,
      allowInput: true,
      altFormat: "d.m.Y",
      onOpen: function (selectDates, dateStr, instance) {
        instance._input.readOnly = true
      },
      onClose: function (selectDates, dateStr, instance) {
        instance._input.readOnly = false
        instance._input.blur()
      }
    });

    this.fpInvoiceDate = flatpickr("#invoiceDateWrapper", {
      dateFormat: "d.m.Y",
      weekNumbers: "true",
      wrap: true,
      locale: localeToUse,
      altInput: true,
      allowInput: true,
      altFormat: "d.m.Y",
      onOpen: function (selectDates, dateStr, instance) {
        instance._input.readOnly = true
      },
      onClose: function (selectDates, dateStr, instance) {
        instance._input.readOnly = false
        instance._input.blur()
      }
    });
  }

  async clickedLogin(event) {
    event.preventDefault();


    if(this.invoiceDateTarget.value){
    var dateSelected = Date.parseExact(this.invoiceDateTarget.value, "dd.MM.yyyy");
    var dateNowExact = new Date();
    var dateNow = new Date(dateNowExact.getFullYear(), dateNowExact.getMonth(), dateNowExact.getDate());
    var isValid = dateSelected.getTime() < +dateNow.getTime();

      if (!isValid) {
        this.fpInvoiceDate.clear()
      }
    }
    

    if (!this.formTarget.checkValidity()) {
      this.formTarget.classList.add("was-validated")
    } else {
      this.formTarget.submit()
    }
  }
}